var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"AssetIcon"},[(_vm.fontHasIcon)?_c('cryptoicon',{attrs:{"symbol":_vm.uSymbol,"size":_vm.size}}):_c('img',{staticClass:"AssetIcon__img",style:(("width:" + _vm.size + "px;height:" + _vm.size + "px;")),attrs:{"src":_vm.asset.rid
        ? ("https://s2.coinmarketcap.com/static/img/coins/64x64/" + (_vm.asset.rid) + ".png")
        : _vm.cointrackrLogo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }